// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__19izw","checkboxCol":"Table_checkboxCol__2Huze","emailCol":"Table_emailCol__2kGCr","actionCol":"Table_actionCol__2sUt-"};